import { render, staticRenderFns } from "./AthleteSelfAssessmentSummary.vue?vue&type=template&id=01d4c5a6&scoped=true&"
import script from "./AthleteSelfAssessmentSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentSummary.vue?vue&type=style&index=0&id=01d4c5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4c5a6",
  null
  
)

export default component.exports